import {
    Directive,
    ElementRef,
    Input,
    AfterViewInit,
    OnChanges,
    SimpleChanges,
  } from '@angular/core';
  
  @Directive({
    standalone: true,
    selector: '[tooltipIfTruncated]',
  })
  export class TooltipIfTruncatedDirective implements AfterViewInit, OnChanges {
    /** The text we want to show in the tooltip if truncated. */
    @Input('tooltipIfTruncated') tooltipText = '';
    private resizeObserver: ResizeObserver;
  
    constructor(private elRef: ElementRef) {
      this.resizeObserver = new ResizeObserver(() => this.updateTooltip());
    }
  
    ngAfterViewInit(): void {
      // We delay checking a bit so rendering can settle
      setTimeout(() => this.updateTooltip());
      this.resizeObserver.observe(this.elRef.nativeElement);
    }
  
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['tooltipText']) {
        // If the text changes, re-check truncation
        setTimeout(() => this.updateTooltip());
      }
    }
    ngOnDestroy(): void {
      // Clean up the ResizeObserver when the directive is destroyed
      this.resizeObserver.disconnect();
    }
  
    private updateTooltip(): void {
      const element: HTMLElement = this.elRef.nativeElement;
      console.log(
        'updateTooltip',
        element.innerText,
        element.scrollWidth,
        element.clientWidth
      );
      // Check if the text is overflowing
      if (element.scrollWidth > element.clientWidth) {
        // Text is truncated -> show native tooltip
        element.setAttribute('title', this.tooltipText);
      } else {
        // Text is not truncated -> remove tooltip
        element.removeAttribute('title');
      }
    }
  }
  